<template>
    <icon-base v-bind="$props">
        <path d="M5 4v16" />
        <path d="M5 5h11l-2 3.5l2 3.5h-11" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
